import { useNavigate } from "react-router-dom";
import "./ErrorPages.css";

const Unauthorized = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);

                if (parsedUser.role?.toLowerCase() === "admin") {
                    navigate("/dashboard");
                } else if (parsedUser.role?.toLowerCase() === "student") {
                    navigate("/applicant/home");
                } else {
                    navigate("/");
                }
            } catch (e) {
                console.error("Error parsing user", e);
                navigate("/");
            }
        } else {
            navigate("/");
        }
    };

    return (
        <div className="error-container">
            <h1 className="error-code">403</h1>
            <h2 className="error-title">Unauthorized Access</h2>
            <p className="error-message">
                You do not have permission to access this page.
            </p>

            <button className="error-button" onClick={handleReturnHome}>
                Return to Home
            </button>
        </div>
    );
};

export default Unauthorized;